import React from 'react'
import './LoginButton.css'

const LoginButton = ({
    type = 'primary',
    onPress,
    title,
    disabled = false,
    textStyles = {},
    ...rest
}) => {
    return (
        <div className={`${type}Button`} onClick={onPress} {...rest}>
            <h1 className='titleButton' style={textStyles}>{title}</h1>
        </div>
    )
}

export default LoginButton